<template>
  <div>
    <slot :handle-click="handleClick" :open="open" name="trigger"></slot>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div v-show="open">
        <slot :focus="focus" name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from "vue";

const open = ref(false);

const handleClick = () => {
  open.value = !open.value;
};

const start = (el) => {
  el.style.height = el.scrollHeight + "px";
};

const end = (el) => {
  el.style.height = "";
};
</script>
